/** @format */

/**
 * Span 原始日志抽屉：以 JSON 只读展示当前 Span，由父组件控制 visible / onClose。
 */

import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { _$, Drawer, Tab, Tabs, Button } from '@king-design/react'
import type { TraceAnalysisDetailSpan } from '../typescript'
import { JsonCode } from 'src/components'

import { TraceEventLogItem } from 'src/api/ApiAIObservability'

export interface TraceSpanLogProps {
  className?: string
  visible: boolean
  span: TraceAnalysisDetailSpan | null
  onClose: () => void
  eventList: TraceEventLogItem[]
}

/** 将 Span 格式化为缩进 JSON 字符串 */
function formatSpanJson(span: TraceAnalysisDetailSpan | null): string {
  if (!span) {
    return ''
  }
  try {
    // 删除span中的bgColor属性
    const { BgColor, ...rest } = span
    return JSON.stringify(rest, null, 2)
  } catch {
    return ''
  }
}

type TabType = 'span' | 'event'

const TraceSpanLog: React.FC<TraceSpanLogProps> = ({
  className,
  visible,
  onClose,
  span,
  eventList
}) => {
  const jsonValue = useMemo(() => formatSpanJson(span), [span])
  const [tab, setTab] = useState<TabType>('span')

  const contentString = useMemo(() => {
    return tab === 'span' ? jsonValue : JSON.stringify(eventList, null, 2)
  }, [tab, jsonValue, eventList])

  return (
    <div className={className} id="trace_span_detail_drawer">
      <Drawer
        value={visible}
        width={800}
        slotHeader={
          <Tabs value={tab} onChangeValue={value => setTab(value as TabType)}>
            <Tab value="span">{_$('Span详情')}</Tab>
            <Tab value="event">{_$('事件')}</Tab>
          </Tabs>
        }
        mode="destroy"
        container={() => document.getElementById('trace_span_detail_drawer')}
        slotFooter={<Button onClick={onClose}>{_$('关闭')}</Button>}
        onChangeValue={show => {
          if (!show) {
            onClose()
          }
        }}
      >
        <JsonCode title={span?.Name || span?.SpanId} jsonstring={contentString} />
      </Drawer>
    </div>
  )
}

export default styled(TraceSpanLog)``
